import { render, staticRenderFns } from "./WorkspaceTopbarIcon.vue?vue&type=template&id=0fdacc2d&"
import script from "./WorkspaceTopbarIcon.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceTopbarIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceTopbarIcon.vue?vue&type=style&index=0&id=0fdacc2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports